export const REFERRAL_KEY='fotg_affiliate_referral_v1';
export const REFERRAL_WINDOW_MS=30*24*60*60*1000;
export function readReferral(storage=localStorage,now=Date.now()){
 try{const r=JSON.parse(storage.getItem(REFERRAL_KEY)||'null');if(!r||!/^[A-Z0-9_]{12,64}$/.test(r.code)||!Number.isFinite(r.expires)||r.expires<=now)return null;return r;}catch{return null;}
}
export function rememberReferral(record,storage=localStorage,now=Date.now()){
 const r={code:record.code,display_name:record.display_name,campaign_id:record.campaign_id,event_path:record.event_path,expires:now+REFERRAL_WINDOW_MS};
 try{storage.setItem(REFERRAL_KEY,JSON.stringify(r));}catch{}return r;
}
